import ProposalSummary from "../../Pages/ProposalSummary";
import { navigationMapBuilder } from "./helpers";

const navigation = [
  {
    header: "Proposal Summary",
    links: [
      {
        text: "Proposal Summary",
        icon: <></>,
        route: "",
        component: ProposalSummary,
      },
    ],
  },
];

const navigationMap = (parentRoute,layout) =>
  navigationMapBuilder(parentRoute, navigation,layout);


export default navigationMap;
